import clsx from "clsx";
import { labelStyle } from "../index";

export default function SumALT({ summary, onSummary }) {
  return (
    <>
      <label className={labelStyle}>Description</label>
      <textarea
        className={textStyle}
        type="summary"
        value={summary}
        placeholder={summary || "Write a summary about the article here"}
        onChange={(e) => onSummary(e.target.value)}
      />
    </>
  );
}

const textStyle = clsx(
  "border-2 p-2 my-4 text-sm rounded-md focus:outline-none w-full h-[100px]"
);
